import { Injectable } from '@angular/core';
import { SafeHtml } from '@angular/platform-browser';
import { Observable } from 'rxjs/Observable';
import { Subject } from 'rxjs/Subject';
import { BehaviorSubject } from 'rxjs/BehaviorSubject';
import { Logger } from 'app/core/index';

const logger = new Logger('alert.service.ts');

export interface AlertObject {
  id: string;
  title: string;
  text?: string | SafeHtml;
  timer?: number;
  icon: string;
}

@Injectable()
export class AlertService {
  public _alerts: Array<any> | null = [];
  private _alertSubject: Subject<Array<any> | null> = new BehaviorSubject([]);
  alerts$: Observable<Array<any> | null> = this._alertSubject.asObservable();

  timers = [];

  constructor() {}

  remove(alert: AlertObject) {
    clearTimeout(this.timers[alert.id]);
    delete this.timers[alert.id];
    this._alerts.splice(this._alerts.indexOf(alert), 1);
    this._alertSubject.next(this._alerts);
  }

  error(params: { title?: string; text?: string | SafeHtml; timer?: number }) {
    const options = {
      title: params.title || null,
      text: params.text || null,
      timer: params.timer || null,
      icon: 'fa-exclamation-triangle',
    };
    this.message(options);
  }

  success(params: { title: string; text?: string | SafeHtml; timer?: number }) {
    const options = {
      title: params.title,
      text: params.text || null,
      timer: params.timer || null,
      icon: 'fa-check',
    };
    this.message(options);
  }

  private makeId(): string {
    let text = 'id-';
    const possible = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789';

    for (let i = 0; i < 6; i++) {
      text += possible.charAt(Math.floor(Math.random() * possible.length));
    }

    return text;
  }

  message(params: { id?: string; title: string; text?: string | SafeHtml; timer?: number; icon: string }) {
    // set alert id
    params.id = this.makeId();

    // set alert timeout
    if (params.timer) {
      this.timers[params.id] = setTimeout(() => {
        delete this.timers[params.id];
        this._alerts.splice(this._alerts.indexOf(params), 1);
        this._alertSubject.next(this._alerts);
      }, params.timer * 1000);
    }
    logger.info('alert->message()', params, this._alerts);
    this._alerts.push(params);
    this._alertSubject.next(this._alerts);
  }
}



// WEBPACK FOOTER //
// /var/lib/jenkins/workspace/Prod_web-client/src/app/core/alert.service.ts